import WhiteCardInfo from "../../typographies/WhiteCardInfo";

interface Props {
  startDatum: string;
  endDatum: string | undefined | null;
}

const DateRange = ({ startDatum, endDatum }: Props) => {
  const range = endDatum
    ? startDatum.substring(0, 10) + " - " + endDatum.substring(0, 10)
    : startDatum.substring(0, 10);
  return <WhiteCardInfo text={range} />;
};

export default DateRange;
